import { render } from "./Home.vue?vue&type=template&id=29d80d62&ts=true"
import script from "./Home.vue?vue&type=script&lang=ts"
export * from "./Home.vue?vue&type=script&lang=ts"

import "./Home.vue?vue&type=style&index=0&id=29d80d62&lang=css"

import exportComponent from "/builds/rgLPqy5NH/0/rockwool/super-wykonawca-2022/performer-rating-2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__